import React, { ReactNode, useEffect, ReactElement } from 'react';

import { request } from 'app/utils';
import { useSchool } from 'features/school';
import { AxiosResponse } from 'axios';
import { useAuth } from 'features/auth';
import { useAgreements, AgreementsApiResponse } from 'features/agreements';

interface UnsignedAgreementsProps {
  children: ReactNode;
}

const UnsignedAgreements = ({ children }: UnsignedAgreementsProps): ReactElement => {
  const { apiGatewayUrl } = useSchool();
  const { token } = useAuth();
  const { setAgreements, setShowAgreementsMessage } = useAgreements();

  const fetch = () => {
    request({
      url: `/api/v1/School/Agreements/unsigned`,
      method: 'get',
      baseURL: apiGatewayUrl,
    }).then((response: AxiosResponse<AgreementsApiResponse>) => {
      setAgreements(response.data);
      setShowAgreementsMessage(!!response.data.agreements.length);
    });
  };

  useEffect(() => {
    if (token?.token) fetch();
  }, [token?.token]);

  return <>{children}</>;
};

export default UnsignedAgreements;
